import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";

const ActionDialog = ({
  visible,
  actionType,
  onHide,
  onSubmit,
  remarks,
  setRemarks
}) => {

  const showRemarks = actionType === "REJECTED" || actionType === "REVIEW";
  const isSubmitDisabled = showRemarks && !remarks.trim();
  const footer = (
    <div className="flex justify-content-end gap-2">
      <Button label="Cancel" className="p-button-text" onClick={onHide} />
      <Button
        label="Submit"
        className="p-button-primary"
        onClick={onSubmit}
        disabled={isSubmitDisabled}
      />
    </div>
  );

  return (
    <Dialog
      header={`${actionType} Confirmation`}
      visible={visible}
      style={{ width: "30vw" }}
      onHide={onHide}
      footer={footer}
    >
      <p>Are you sure you want to <strong>{actionType}</strong> the selected records?</p>

      {showRemarks && (
        <div className="mt-3">
          <label htmlFor="action-remarks">Remarks <span className="p-error">*</span></label>
          <InputTextarea
            id="action-remarks"
            rows={3}
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            placeholder="Enter remarks"
            className="w-full"
            {...(isSubmitDisabled && { className: "w-full p-invalid" })} 
            aria-describedby="remarks-help"
          />
          {isSubmitDisabled && (
              <small id="remarks-help" className="p-error">Remarks are mandatory for this action.</small>
          )}
        </div>
      )}
    </Dialog>
  );
};

export default ActionDialog;